export var noTransition = {
    from: {
        opacity: 1,
    },
    enter: {
        opacity: 1,
    },
    leave: {
        opacity: 0,
    },
};
